<template>
  <section class="cards">
    <transition name="shortfade" mode="out-in">
      <div class="cards__container" v-if="visibleFlats.length" key="1">
        <pagination
          class="cards__pagination--mobile"
          :flats="sorted || []"
        ></pagination>
        <div class="cards__sorting">
          <icon class="cards__icon">
            <img src="@/assets/settings.png" alt="" />
          </icon>
          <button
            class="cards__button"
            @click="sortBy.type = sortBy.type == 'asc' ? 'desc' : 'asc'"
          >
            <span v-if="sortBy.type == 'desc'">rosnąco</span>
            <span v-else>malejąco</span>
          </button>
          <button
            @click="sortBy.property = flatProperties['area']"
            class="cards__button"
            :class="{ active: sortBy.property == flatProperties['area'] }"
          >
            metraz
          </button>
          <button
            @click="sortBy.property = flatProperties['price']"
            class="cards__button"
            :class="{ active: sortBy.property == flatProperties['price'] }"
          >
            cena
          </button>
          <button
            @click="sortBy.property = flatProperties['rooms']"
            class="cards__button"
            :class="{ active: sortBy.property == flatProperties['rooms'] }"
          >
            pokoje
          </button>
          <button
            @click="sortBy.property = flatProperties['floor']"
            class="cards__button"
            :class="{ active: sortBy.property == flatProperties['floor'] }"
          >
            pietro
          </button>
        </div>

        <transition-group name="flats" class="cards__grid" tag="div">
          <card
            v-for="flat in visibleFlats"
            :key="flat[flatProperties['id']]"
            :flat="flat"
          ></card>
        </transition-group>
        <pagination :mb="false" :flats="flats"></pagination>
      </div>
      <div class="cards__empty" v-else key="2">
        <p>Brak mieszkań spełniających wymagania</p>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";

// Components
import icon from "@/components/icon.vue";
import card from "@/components/flat/flat-card.vue";
import pagination from "@/components/pagination";

export default {
  name: "list",
  data() {
    return {
      sortBy: {
        property: "",
        type: "desc",
      },
    };
  },
  components: { card, pagination, icon },
  computed: {
    ...mapState({
      flatsOnPage: (state) => state.browser.flatsOnPage,
      flatProperties: (state) => state.browser.flatProperties,
    }),
    flats() {
      if (this.floor)
        return this.$store.getters.GET_FILTERED_FLATS_BY_FLOOR(this.floor);

      return this.$store.getters.GET_FIILTERED_FLATS;
    },
    sorted() {
      return this.$store.getters.GET_SORTED_AND_FILTERED_FLATS(
        this.sortBy.property,
        this.sortBy.type
      );
    },
    page() {
      return this.$route.query.page ? this.$route.query.page - 1 : 0;
    },
    visibleFlats() {
      return [...this.sorted].splice(
        this.flatsOnPage * this.page,
        this.flatsOnPage
      );
    },
    filters() {
      return this.$store.state.filters;
    },
  },
  watch: {
    filters() {
      if (this.page > 1) {
        this.$router.replace({ query: { ...this.$route.query, page: 1 } });
      }
    },
  },
  mounted() {
    this.sortBy.property = this.flatProperties["floor"];
  },
};
</script>

<style lang="scss">
.cards {
}

.cards__container {
  max-width: 1000px;
  width: 100%;
  margin: {
    top: 14px;
    left: auto;
    right: auto;
  }

  @media screen and (max-width: 1230px) {
    padding: 0 16px;
  }
}

.cards__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 300px));
  grid-gap: 40px;
  @media screen and (max-width: $xxl) {
    grid-template-columns: repeat(3, minmax(250px, 1fr));
    grid-gap: 30px;
  }
  @media screen and (max-width: $lg) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  @media screen and (max-width: 400px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

.cards__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  p {
    font-weight: 500;
    font-size: 24px;
  }
}

.cards__sorting {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.cards__icon {
  margin-right: 6px;
  margin-bottom: 6px;
}

.cards__button {
  border: 1px solid $lightGray;
  background: #fff;
  border-radius: 8px;
  padding: 10px 11px;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
  margin-right: 6px;
  margin-bottom: 6px;
  transition: 200ms;

  &:hover,
  &.active {
    border: 1px solid $primaryColor;
  }
}

.cards__pagination--mobile {
  @media screen and(min-width: $md) {
    display: none !important;
  }
}
</style>
